import {relationGroupsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { editRelationGroupLoading : true, data: '', error: false};

export function editRelationGroup(state = initialState, action) {
    switch (action.type) {
      case relationGroupsConstants.REQUEST_EDIT_RELATION_GROUP:
        return {
          editRelationGroupLoading: true,
          data: '',
          error: false
        };
      case relationGroupsConstants.RECEIVE_EDIT_RELATION_GROUP:
      swal({
        text: 'Relation Group Updated Successfully',
        type: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
        return {
          editRelationGroupLoading: false,
          data: action.relationGroup,
          error: false
        };
      case relationGroupsConstants.EDIT_RELATION_GROUP_ERROR:
        return { 
          editRelationGroupLoading: false,
          data: '',
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/editRelationGroup.reducer.js